import * as React from "react";
import styled from "styled-components";
import { PortableText } from "@portabletext/react";
const StylableRichTextPortableText = ({ rawPortableText, supportedTags, ...htmlProps }) => {
    return React.createElement("div", { ...htmlProps }, rawPortableText && React.createElement(PortableText, { value: rawPortableText }));
};
StylableRichTextPortableText.defaultProps = {
    "data-testid": "rich-text-portable-text",
};
export const RichTextPortableText = styled(StylableRichTextPortableText) ``;
//# sourceMappingURL=RichTextPortableText.js.map